import { Typography } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import React from 'react';
import img from '../../assets/img/rs_school.svg';
import './footer.css';
var Footer = function () {
    return (React.createElement("div", { className: "footer" },
        React.createElement("div", { className: "rs-logo" },
            React.createElement("a", { href: "https://rs.school/" },
                React.createElement("img", { src: img, alt: "rs-logo" }))),
        React.createElement("div", { className: "app-year" },
            React.createElement(Typography, null, "(c) 2022")),
        React.createElement("div", { className: "githubs" },
            React.createElement("div", { className: "github" },
                React.createElement(GitHubIcon, null),
                React.createElement("a", { href: "https://github.com/UserJah" },
                    React.createElement(Typography, null, "\u0420\u0443\u0441\u0442\u0430\u043C"))),
            React.createElement("div", { className: "github" },
                React.createElement(GitHubIcon, null),
                React.createElement("a", { href: "https://github.com/jardozzz" },
                    React.createElement(Typography, null, "\u0418\u043B\u044C\u044F"))),
            React.createElement("div", { className: "github" },
                React.createElement(GitHubIcon, null),
                React.createElement("a", { href: "https://github.com/PartyZzzan77" },
                    React.createElement(Typography, null, "\u0414\u043C\u0438\u0442\u0440\u0438\u0439"))))));
};
export default Footer;
